import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}

import { loadLocale } from '@/i18n';
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useGame } from '@/store';
import Result from '@ui/views/Result.vue';
import Partition from '@ui/views/Partition.vue';
import Home from '@ui/views/Home.vue';
import ModalEntry from '@ui/components/ModalEntry.vue';
import Loading from '@ui/components/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const gameStore = useGame();
const { characters, games, isInitReady } = storeToRefs(gameStore);
const { init } = gameStore;
const isEventReady = ref(false);

onMounted(async () => {
  await loadLocale(process.env.LOCALE);
  isEventReady.value = true;
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isEventReady.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(isInitReady) && _unref(games))
            ? (_openBlock(), _createBlock(Result, { key: 0 }))
            : (_unref(isInitReady) && _unref(characters))
              ? (_openBlock(), _createBlock(Partition, { key: 1 }))
              : (_openBlock(), _createBlock(Home, { key: 2 }))
        ]))
      : _createCommentVNode("", true),
    _createVNode(ModalEntry),
    _createVNode(Loading)
  ]))
}
}

})